import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

function SideList(props) {
  const {
    lastOpenedChild,
    title,
    disabled,
    notifWhoOpened,
    children,
    tooltip,
  } = props;

  const [show, setShow] = useState(false);
  const [justOpen, setJustOpen] = useState(false);

  let hovered = false;

  useEffect(() => {
    // check if just opened list is "me" list, if not, close myself
    if (lastOpenedChild !== title) {
      setShow(false);
    }
  }, [lastOpenedChild, title]);

  const toggle = () => {
    if (!disabled && !justOpen) {
      if (!show) notifWhoOpened(title);
      setShow(!show);
    }
  };

  const showMe = () => {
    if (!disabled && hovered) {
      notifWhoOpened(title);
      setShow(true);
      setJustOpen(true);
      setTimeout(() => {
        setJustOpen(false);
      }, 300);
    }
  };

  const onHovered = () => {
    hovered = true;
    setTimeout(() => {
      showMe();
    }, 300);
  };

  const sidelist = <OverlayScrollbarsComponent defer options={{ scrollbars: { autoHide: 'leave', autoHideDelay: '100' } }} className="side-list">{children}</OverlayScrollbarsComponent>;

  const header = (
    <div
      className="side-list-main-header"
      data-testid={`advanced-filter-group[${title}]`}
      data-tooltip-id={tooltip ? 'tooltip' : undefined}
      data-tooltip-content={tooltip}
      data-tooltip-place={tooltip ? 'top-end' : undefined}
      data-tooltip-position-strategy={tooltip ? 'fixed' : undefined}
      aria-label={tooltip}
      onClick={toggle}
      onMouseEnter={onHovered}
      onMouseLeave={() => {
        hovered = false;
      }}
    >
      <div className={!disabled ? 'enabled' : 'disabled'}>
        <div className={show ? 'active' : 'non-active'}>
          <div className="arrow" />
          <div className="title">{title}</div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="side-list-container">
      {header}
      {show && sidelist}
    </div>
  );
}

SideList.propTypes = {
  lastOpenedChild: PropTypes.string.isRequired,
  notifWhoOpened: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  children: PropTypes.any,
  disabled: PropTypes.any,
};

export default SideList;